<template>
  <ul class="flex space-x-2 flex-wrap space-y-1 justify-start">
    <li v-for="variant in product.variants" :key="variant.variant_id"
        @click="() => selectVariant(variant.variant_id)"
        class="rounded-full  w-12 h-12 flex items-center justify-center text-center font-500 cursor-pointer"
        :class="{
          'bg-black text-white': selected === variant.variant_id,
          'bg-gray-200': selected !== variant.variant_id,
        }"
    >
        {{ variant.name }}
    </li>
  </ul>
</template>
<script lang="ts" setup>

import type {Product} from "~/models/product";

const {product} = defineProps<{ product: Product }>()

const selected = ref<string|undefined>(undefined)
const emit = defineEmits<{
  'update:modelValue': [variantId: string]
}>()

const selectVariant = (variantId: string) => {
  selected.value = variantId
  emit('update:modelValue', variantId)
}

</script>